import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { ReactComponent as SpinnerSvg } from '@assets/icon/icn_spinner.svg';

const SpinnerWrapper = styled.i`
  display: inline-block;
  vertical-align: center;
  width: ${({ size }) => size || '30px'};
  height: ${({ size }) => size || '30px'};
`;

const Spinner = ({ style, isloading = true, size }) =>
  isloading && (
    <SpinnerWrapper size={size} style={style}>
      <SpinnerSvg width="100%" height="100%" />
    </SpinnerWrapper>
  );

Spinner.propTypes = {
  style: PropTypes.objectOf(PropTypes.string),
  isloading: PropTypes.bool,
  size: PropTypes.string,
};

export default Spinner;
